import React, {useState, useEffect} from 'react';
import {r} from "@/utils/responsive";

interface MobileTabletScreenProps extends React.HTMLAttributes<HTMLDivElement> {
}

const MobileTabletScreen: React.FC<MobileTabletScreenProps> = ({className, ...props}) => {
    const [isMobile, setIsMobile] = useState(false);
    const [isTablet, setIsTablet] = useState(false);

    useEffect(() => {
        const media = window.matchMedia('(pointer: coarse)');
        const checkMobile = () => {
            const ua = navigator.userAgent || '';
            const width = window.innerWidth;
            const isTouch = ('ontouchstart' in window) || (navigator.maxTouchPoints || 0) > 0;
            const isCoarse = media.matches;
            const uaMobile = /Mobi|Android(?!.*Tablet)|iPhone|iPod/i.test(ua);
            const uaTablet = /iPad|Tablet|SM-T|Tab/i.test(ua) || (/Android/i.test(ua) && !/Mobile/i.test(ua));

            const mobile = (width < 768) || (isCoarse && width < 900) || uaMobile;
            const tablet = !mobile && ((width >= 768 && width < 1440) || isCoarse || uaTablet || (isTouch && width < 1440));

            setIsMobile(mobile);
            setIsTablet(tablet);
        };

        // Проверка при загрузке
        checkMobile();

        // Слушаем изменения размера окна
        window.addEventListener('resize', checkMobile);
        if (typeof media.addEventListener === 'function') {
            media.addEventListener('change', checkMobile);
        } else if (typeof media.addListener === 'function') {
            // @ts-ignore
            media.addListener(checkMobile);
        }

        return () => {
            window.removeEventListener('resize', checkMobile);
            if (typeof media.removeEventListener === 'function') {
                media.removeEventListener('change', checkMobile);
            } else if (typeof media.removeListener === 'function') {
                // @ts-ignore
                media.removeListener(checkMobile);
            }
        };
    }, []);

    return (
        <div
            {...props}
            style={{
                position: 'fixed',
                inset: 0,
                background: '#110B29',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                overflow: 'hidden',
                ...props.style
            }}
        >
            <h1 style={{
                whiteSpace: 'pre-wrap',
                fontSize: isMobile ? '30px' : isTablet ? '40px' : '48px',
                lineHeight: isMobile ? '34px' : isTablet ? '46px' : '54px',
                color: 'white',
                position: 'relative',
                zIndex: 3,
                textAlign: 'center',
                padding: 0,
            }}>{`Привет! Спасать \nКонтейнерленд удобнее \nс компьютера`}</h1>
        </div>
    );
};

export default MobileTabletScreen;
